import { FC } from 'react';
import { Box } from '@altermaind/web/ui';
import { useDialog } from '@/_shared/hooks';
import { DialogContactsFeedbackPayload, DialogContactsPayload } from '../types';
import { ErrorContent } from './ErrorContent';
import { SuccessContent } from './SuccessContent';

export const DialogContactsFeedback: FC = () => {
  const { closeDialog, Dialog, isOpen, payload } =
    useDialog<DialogContactsFeedbackPayload>('contactsFeedback');
  const { openDialog: openContactsDialog } = useDialog<DialogContactsPayload>('contacts');

  const handleClose = () => {
    closeDialog();
  };

  const handleRetry = () => {
    const previousValues = payload?.formValues;
    closeDialog();
    openContactsDialog(previousValues ? { initialValues: previousValues } : undefined);
  };

  const status = payload?.status ?? 'success';

  return (
    <Dialog maxWidth='550px' open={isOpen} title={undefined} onClose={handleClose} closeButton>
      <Box mt='m'>
        {status === 'success' ? (
          <SuccessContent onClose={handleClose} />
        ) : (
          <ErrorContent onRetry={handleRetry} onClose={handleClose} />
        )}
      </Box>
    </Dialog>
  );
};
